import BaseComponent from 'foundation/base-component';
import anime from 'animejs';
import app from 'general/js/app';
import gtm from 'general/js/gtm';
import { spaLoad } from 'components/spa-load';

const EASING = 'easeOutQuad';

export default class LiveNavigation extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    static getRequiredRefs() {
        return [
            'link'
        ];
    }

    onDestroy() {
        this.unsubscribeHisporyChange();
    }

    init() {
        this.highlightSelected();
        this.unsubscribeHisporyChange = spaLoad.subscribeOnHistoryChange(() => {
            this.highlightSelected();
        });

        this.refs.link.forEach((link) => {
            this.addListener(link, 'click', this.onNavigationLinkClick);
            this.addListener(link, 'click', this.saveActionToGtm);
        });
    }

    saveActionToGtm = (event) => {
        const clickedItem = event.target;
        const itemText = clickedItem.innerText || clickedItem.textContent;
        if (clickedItem && clickedItem.tagName === 'A') {
            gtm.push('Top Ribbon', 'Click', itemText);
        }
    }

    highlightSelected = () => {
        this.clearSelection(this.refs.link);
        this.refs.selector.classList.remove('is-visible');

        const link = this.getActiveLink();
        if (link) {
            link.classList.add('is-active');
            this.refs.selector.style.left = this.calculateSelectorPosition(link);
            this.refs.selector.classList.add('is-visible');
        }
    };

    getActiveLink() {
        let result = null;
        const pathname = this.getNormalizedPathname();
        for (const i in this.refs.link) {
            const link = this.refs.link[i];

            if (link.getAttribute('href') === pathname) {
                result = link;
                break;
            } else {
                const aliasesAttribute = this.getAttribute(link, 'aliases');
                if (aliasesAttribute) {
                    const aliases = JSON.parse(aliasesAttribute);
                    const activeAlias = aliases.find((a) => pathname.includes(a));
                    if (activeAlias) {
                        result = link;
                        break;
                    }
                }
            }
        }

        return result;
    }

    getNormalizedPathname() {
        // for the same page window.location.pathname can return slightly different results
        // case 1: manually enter url in the search bar, for example /watch/
        // result 1: window.location.pathname returns /watch/
        // case 2 navigate via links with href="/watch"
        // result 2: returns /watch
        // so there is no normalization within Location object so we have to do it ourselves
        // and always return pathname without trailing slash
        let pathname = window.location.pathname;
        if (pathname.length > 1 && pathname[pathname.length - 1] === '/') {
            pathname = pathname.slice(0, pathname.length - 1);
        }

        return pathname;
    }

    clearSelection(nodesArray) {
        nodesArray.forEach((node) => {
            if (node.classList.contains('is-active')) {
                node.classList.remove('is-active');
            }
        });
    }

    onNavigationLinkClick = (event) => {
        if (app.isEditMode) return;

        const ignoreSpa = event.currentTarget.getAttribute('data-ignore-spa') === 'true';

        if (!ignoreSpa) {
            event.preventDefault();
            this.navigate(event.target);
        }
    };

    navigate(link) {
        if (!link) {
            return;
        }

        if (this.currentAnimation) {
            this.currentAnimation.pause();
            this.currentAnimation = null;
        }

        const leftCoord = this.calculateSelectorPosition(link);
        this.refs.selector.classList.add('is-visible');
        this.currentAnimation = anime({
            targets: this.refs.selector,
            left: leftCoord,
            duration: 250,
            easing: EASING,
            complete: () => {
                spaLoad.updateContent(link.getAttribute('href'));
                this.currentAnimation = null;
            }
        });
    }

    calculateSelectorPosition(item) {
        const itemWidth = item.clientWidth;
        const navigationCoords = this.element.getBoundingClientRect();
        const itemCoords = item.getBoundingClientRect();
        const itemPosition = itemCoords.left - navigationCoords.left;
        const selectorWidth = this.refs.selector.clientWidth;

        return itemPosition + (itemWidth / 2) - (selectorWidth / 2) + 'px';
    }
}
